'use strict';

import * as util from '../util/Common.js';
import {EventManager} from '../util/EventManager.js';
import {Point2D} from '../util/Geometry.js';
import * as domUtil from '../util/Dom.js';
import {UiComponent} from '../ui/UiComponent.js';
import {RelativeContainer} from '../ui/RelativeContainer.js';

const privateMap = util.createPrivateMapper();

export class SequenceController extends EventManager {
  constructor(sequence){
    super();
    const pv = privateMap(this);
    pv.viewTypes = sequence.viewTypes ? [...sequence.viewTypes] : [];
    pv.label = sequence.label;
    pv.sequence = sequence;
    pv.sequenceOptions = sequence.options
    pv.reverseOrder = sequence.reverseOrder
    pv.scenes = sequence.scenes ? sequence.scenes : [];
    pv.sceneIds = {}
    for (let i = 0; i < pv.scenes.length; i++) {
      pv.sceneIds[pv.scenes[i].id] = i
    }
    pv.currentViewNo = -1;
    pv.currentSceneNo = -1;
    pv.currentSceneNos = []
    pv.loadingScene = null;
    this.views = null
  }
  get viewTypes(){
    return privateMap(this).viewTypes;
  }
  set views(views){
    const pv = privateMap(this);
    if (!views) {
      pv.views = []
      pv.sceneViewRef = []
      for (let i = 0; i < pv.scenes.length; i++) {
        pv.views[i] = {
          sceneIdxs: [i]
        }
        pv.sceneViewRef[i] = i
      }
    } else {
      pv.views = views
      pv.sceneViewRef = []
      for (let viewIdx = 0; viewIdx < pv.views.length; viewIdx++) {
        const sceneIdxs = pv.views[viewIdx].sceneIdxs
        for (let i = 0; i < sceneIdxs.length; i++) {
          pv.sceneViewRef[sceneIdxs[i]] = viewIdx
        }
      }
    }
    this.sceneNo = pv.currentSceneNo
  }
  get label(){
    return privateMap(this).label;
  }
  get sceneNo(){
    return privateMap(this).currentSceneNo;
  }
  get reverseOrder(){
    return privateMap(this).reverseOrder;
  }
  get sequenceOptions(){
    return privateMap(this).sequenceOptions
  }
  nextView(){
    const pv = privateMap(this);
    if (pv.currentViewNo < 0 || !(pv.currentViewNo + 1 < pv.views.length)){
      return
    }
    this.dispatchEvent('nextview', {
    });
    this.viewNo = pv.currentViewNo + 1
  }
  prevView(){
    const pv = privateMap(this);
    if (pv.currentViewNo <= 0){
      return
    }
    this.dispatchEvent('prevview', {
    });
    this.viewNo = pv.currentViewNo - 1
  }
  set viewNo(no){
    const pv = privateMap(this);
    const views = pv.views
    const viewNo = Math.min(views.length - 1, Math.max(0, no));
    const view = pv.views[viewNo]
    let sceneChanged
    if (!view || !view.sceneIdxs || view.sceneIdxs.length < 1) {
      pv.currentSceneNos = []
      if (pv.currentViewNo != -1) {
        pv.currentViewNo = -1
        sceneChanged = pv.currentSceneNo != -1
        this.dispatchEvent('viewchange', {});
        if (sceneChanged) {
          this.dispatchEvent('scenechange', {});
        }
      }
      return
    }
    const sceneNos = view.sceneIdxs
    let isSame = false
    if (pv.currentSceneNos.length == sceneNos.length) {
      isSame = true
      for (let i = 0; i < sceneNos.length; i++) {
        if (pv.currentSceneNos[i] !== sceneNos[i]) {
          isSame = false
          break
        }
      }
    }
    for (let sceneNo of sceneNos) {
      if (sceneNo === null) {
        continue
      }
      sceneChanged = pv.currentSceneNo != sceneNo
      pv.currentSceneNo = sceneNo
      break
    }
  // pv.currentSceneNo = sceneNos[0]
    if (!isSame) {
      pv.currentViewNo = viewNo
      pv.currentSceneNos = sceneNos
      this.dispatchEvent('viewchange', {});
    }
    if (sceneChanged) {
      this.dispatchEvent('scenechange', {});
    }
  }
  get viewNo(){
    return privateMap(this).currentViewNo;
  }
  set sceneNo(no){
    const pv = privateMap(this);
    const scenes = pv.sequence.scenes;
    const sceneNo = Math.min(scenes.length - 1, Math.max(0, no));
    const viewNo = pv.sceneViewRef[sceneNo]
    const view = pv.views[viewNo]
    let sceneChanged = pv.currentSceneNo != sceneNo
    if (!view || !view.sceneIdxs || view.sceneIdxs.length < 1) {
      pv.currentSceneNos = []
      if (pv.currentViewNo != -1) {
        pv.currentViewNo = -1
        sceneChanged = pv.currentSceneNo != -1
        this.dispatchEvent('viewchange', {});
        if (sceneChanged) {
          this.dispatchEvent('scenechange', {});
        }
      }
      return
    }
    const sceneNos = view.sceneIdxs
    pv.currentSceneNo = sceneNo
    let isSame = false
    if (pv.currentSceneNos.length == sceneNos.length) {
      isSame = true
      for (let i = 0; i < sceneNos.length; i++) {
        if (pv.currentSceneNos[i] !== sceneNos[i]) {
          isSame = false
          break
        }
      }
    }
    if (!isSame) {
      pv.currentViewNo = viewNo
      pv.currentSceneNos = sceneNos
      this.dispatchEvent('viewchange', {
      });
    }
    if (sceneChanged) {
      this.dispatchEvent('scenechange', {});
    }
  }
  set sceneId(id){
    const pv = privateMap(this);
    const sceneIdx = pv.sceneIds[id]
    if (sceneIdx >= 0) {
      this.sceneNo = sceneIdx
    }
  }

  get sceneNos(){
    return [...privateMap(this).currentSceneNos];
  }

  get sceneLength(){
    return privateMap(this).scenes.length;
  }

  get viewLength(){
    return privateMap(this).views.length;
  }

  getScene(no){
    const pv = privateMap(this);
    return pv.scenes[no];
  }
  eachScene(fn){
    const pv = privateMap(this);
    util.each(pv.scenes, fn);
  }
  getView(no){
    const pv = privateMap(this);
    return pv.views[no];
  }
  eachView(fn){
    const pv = privateMap(this);
    util.each(pv.views, fn);
  }
}
function resetSequenceViewScene(pv){
  if (pv.resourceLoadObj) {
    pv.resourceLoadObj.abort();
    pv.resourceLoadObj = false;
  }
  if (pv.loadingIndicator) {
    pv.loadingIndicator.close();
  }
  pv.loadingScene = null;
  pv.closeDomLayer();
  pv.closeMessageLayer();
  if (pv.contentView) {
    pv.contentView.reset();
  }
  util.each(pv.currentContentViewComponents, (component) => {
    component.unlink();
  });
  pv.currentContentViewComponents.length = 0;
  util.each(pv.sceneComponents, (component) => {
    component.unlink();
  });
}
function showError(pv, msg, ev) {
  if (ev) {
    console.error(ev);
  }
  if (pv.loadingIndicator) {
    pv.loadingIndicator.close();
  }
  pv.openMessageLayer(pv.createErrorMessage(msg));
}
function changeSequenceViewScene(pv, sceneNo) {
  const contentView = pv.contentView;
  if (!contentView) {
    return
  }
  pv.currentSceneNo = sceneNo;

  const scene = pv.controller.getScene(sceneNo);
  if (!scene) {
    console.error('scene empty. no:' + sceneNo);
    return;
  }
  util.each(pv.sceneComponents, (component) => {
    const scenes = scene ? [scene] : null
    component.link(scenes);
  });

  if (!scene.source) {
    showError(pv, 'scene source empty.', scene);
    return;
  }
  const resourceLoader = pv.resourceLoaders[scene.type];
  if (!resourceLoader) {
    pv.openDomLayer(pv.createUnknownTypeScene(scene));
    // throw new Error('scene type invalid. scene type:' + scene.type);
    return;
  }

  pv.loadingScene = scene;
  if (pv.loadingIndicator) {
    pv.loadingIndicator.open();
  }

  pv.resourceLoadObj = resourceLoader.load(scene.source, (resource) => {
    if (pv.loadingScene != scene) {
      // not a current resource
      return;
    }

    const contentType = pv.contentTypes[resource.type];
    if (!contentType) {
      showError(pv, 'Content type not found. content type:' + resource.type);
      return;
    }
    if (contentType.useWatermark && scene.manifest.watermark) {
      contentView.watermark = scene.manifest.watermark
    }
  
    const contentControl = pv.contentControls[contentType.control];
    if (!contentControl) {
      showError(pv, 'Content control not found. control:' + contentType.control);
      return;
    }

    try {

      util.each(contentType.components, (name) => {
        const component = pv.contentViewComponents[name];
        if (!component) {
          return;
        }
        component.link(contentView);
        pv.currentContentViewComponents.push(component);
      });
      contentControl.resource = resource;

      contentView.setView(contentType.renderer, contentControl, resource);

      if (contentType.initialize) {
        contentType.initialize(contentView);
      }
      contentView.requestRender();

    } catch (error) {
      showError(pv, 'Failed to initialize.', error);
      return;
    }

    const annoQueue = [];
    if (resource.annotationLists) {
      util.each(resource.annotationLists, (annoList) => {
        annoQueue.push(annoList);
      })
    }
    contentView.annotationListRenderer = null;
    if (annoQueue.length) {
      contentView.annotationListRenderer = contentType.annotationListRenderer;
      const annoListResources = [];
      function next(){
        if (annoQueue.length == 0) {
          contentView.annotationListResources = annoListResources;
          return;
        }
        const source = annoQueue.shift();
        pv.resourceLoadObj = pv.annotationListResourceLoader.loadAnnotationList(source, function(annoResource){
          if (pv.loadingScene != scene) {
            // not a current resource
            annoQueue.length = 0;
            return;
          }
          annoListResources.push(annoResource);
          annoResource.size = resource.size;
          next();
        }, {
          failure: (ev) => {
            console.error(ev);
          },
          progress: (ev) => {
            // Do nothing for now
          },
          always: () => {
            pv.resourceLoadObj = false;
          }
        });
      }
      next();
    }
  }, {
    failure: (ev) => {
      if (ev) {
        let err = ev.toString();
        if (ev.meessage) {
          err += '@n' + ev.meessage;
        }
        if (ev.stack) {
          err += '\n' + ev.stack;
        }
        alert(err);
      }
      showError(pv, 'Resource load failure', ev);
    },
    itemStart: (url) => {
      if (pv.loadingIndicator) {
        pv.loadingIndicator.itemStart(url);
      }
    },
    itemProgress: (url) => {
      if (pv.loadingIndicator) {
        pv.loadingIndicator.itemProgress(url);
      }
    },
    progress: (ev, url) => {
      if (pv.loadingIndicator) {
        pv.loadingIndicator.progress(ev, url);
      }
    },
    loaded: (ev) => {
      if (pv.loadingIndicator) {
        pv.loadingIndicator.loaded();
      }
    },
    always: () => {
      pv.resourceLoadObj = false;
      if (pv.loadingIndicator) {
        pv.loadingIndicator.close();
      }
    }
  });
}

export class SequenceView {
  constructor(options){
    const pv = privateMap(this);
    // pv.contentView = options.contentView;
    pv.resourceLoaders = options.resourceLoaders;
    pv.annotationListResourceLoader = options.annotationListResourceLoader;
    pv.contentControls = options.contentControls;
    pv.contentViewComponents = options.contentViewComponents ? options.contentViewComponents : [];
    pv.sceneComponents = options.sceneComponents ? options.sceneComponents : [];
    pv.contentTypes = options.contentTypes;
    pv.createErrorMessage = options.createErrorMessage ? options.createErrorMessage : function(){};
    pv.createUnknownTypeScene = options.createUnknownTypeScene ? options.createUnknownTypeScene : function(){};
    pv.openDomLayer = options.openDomLayer ? options.openDomLayer : function(){};
    pv.openMessageLayer = options.openMessageLayer ? options.openMessageLayer : function(){};
    pv.closeDomLayer = options.closeDomLayer ? options.closeDomLayer : function(){};
    pv.closeMessageLayer = options.closeMessageLayer ? options.closeMessageLayer : function(){};
    pv.loadingIndicator = options.loadingIndicator;

    pv.currentContentViewComponents = [];
    pv.resourceLoadObj = false;
    pv.currentSceneNo = -1;

    pv.viewchangeListener = (ev) => {
      resetSequenceViewScene(pv);
      changeSequenceViewScene(pv, pv.controller.sceneNo);
    };
  }

  set controller(controller) {
    const pv = privateMap(this);
    if (pv.controller) {
      pv.controller.removeEventListener('viewchange', pv.viewchangeListener);
    }
    resetSequenceViewScene(pv);
    pv.controller = controller;
    if (pv.controller) {
      pv.controller.views = null
      pv.controller.addEventListener('viewchange', pv.viewchangeListener);
      if (pv.controller.sceneNo >= 0) {
        changeSequenceViewScene.call(this, pv, pv.controller.sceneNo);
      }
    }
  }

  link(contentView){
    const pv = privateMap(this);
    pv.contentView = contentView
  }
  unlink(){
    const pv = privateMap(this);
    pv.contentView = null
  }

  // get sceneNo(){
  //   privateMap(this).currentSceneNo;
  // }
  // set sceneNo(no){
  //   const pv = privateMap(this);
  //   if (!pv.controller) {
  //     return;
  //   }
  //   const scenes = pv.sequence.scenes;
  //   const contentView = pv.contentView;
  //   const sceneNo = Math.min(scenes.length, Math.max(0, no));
  // }
}